import * as template from './app.hbs';
import './polyfills';
import Component from './component';

export default class App<T extends Component<any>> {

    constructor(private component: T) {
        document.body.innerHTML += template(
            {
                component: component
            },
            {
                allowedProtoMethods: {
                    html: true
                },
                allowedProtoProperties: {
                    html: true
                }

            }
        );
        component.applyBindings(document.body);
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./Frontend/src/component/App.ts